var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZendropLogo = function SvgZendropLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 200,
    height: 45.5,
    viewBox: "0 0 800 182"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "zendrop-logo_svg__a",
    x1: 4.7,
    y1: 786.46,
    x2: 2.2,
    y2: 789.79,
    gradientTransform: "matrix(24.76 0 0 -27.9 -23.76 22351.21)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8472ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b786f6"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M275.33 444.83v-22.42h-31.88l31.88-56.87v-20.67h-63.09v22.42h34.45l-34.45 60.79v16.75Zm45.93 2.44a36.41 36.41 0 0 0 21.34-6.76c6.35-4.32 11.62-10.81 15.27-19.18h-23c-3.1 3.92-6.75 7-13.64 7-8.78 0-16.21-5.27-17.56-14.18h56.19a30.72 30.72 0 0 0 .54-5.94c0-22.84-16.75-40.94-39.58-40.94s-39.31 19.32-39.31 40.26a39.79 39.79 0 0 0 39.75 39.74ZM338 399h-34c.94-4.46 5.4-12.83 17-12.83s16.06 8.41 17 12.83Zm57.28 45.79V404c0-4.6 0-15.67 12.83-15.67 11 0 11.71 9 11.75 14.49v42h22.44V398c0-14.73-4.59-20.67-8.65-24.18s-12-6.49-19.18-6.49c-13.37 0-18.1 6.89-20.4 10.54h-.27v-8h-20.94v75Zm97 2.44c15.13 0 20.54-7.43 22.43-10.54h.29v8.1h21.34v-100H513.9v31.34c-2.43-2.43-8.78-8.92-22-8.92-19.05 0-37.15 14.46-37.15 39.85-.02 22.64 14.84 40.21 37.53 40.21Zm3.65-20.94c-10.54 0-18.78-7.7-18.78-19.32 0-8.65 6.08-18.78 19.05-18.78 12.43 0 18.91 9.73 18.91 18.78 0 7.87-5.11 19.36-19.18 19.36Zm78.89 18.5v-41.2c0-11.35 7.3-13.51 17.7-13.78v-22.52c-13 0-16.89 6.89-18.78 10.54h-.27v-8H552.4v75Zm63.63 2.3c27.29 0 40.39-21.48 40.39-39.85s-13.1-39.85-40.39-39.85-40.39 21.48-40.39 39.85 13.1 39.89 40.39 39.89Zm0-20.94c-9.73 0-18-8-18-18.91s8.24-18.91 18-18.91 18 8 18 18.91-8.27 18.95-18 18.95ZM714 469.83v-31.75c2.7 2.84 9 9.32 22.56 9.32 21.34 0 36.47-17.7 36.47-39.31 0-17.43-10-40.8-36.61-40.8-11.48 0-18.91 5.14-23.37 10.81h-.41v-8.24h-21.1v100Zm17.83-43.37c-11.76 0-18.78-9.59-18.78-19 0-8.91 6.48-19.18 18.78-19.18s18.78 10.27 18.78 19.18c-.03 9.41-7.06 19-18.81 19Z",
    transform: "translate(0 -309)",
    style: {
      fill: "#212240"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined-Shape",
    d: "M119.89 330.27c11.62.13 20.4 6.29 23.74 17.14 2.61 8.51.93 16.51-4.81 23.49Q109.93 406.06 81 441.21c-3.54 4.3-7.07 8.6-10.72 12.8-8.94 10.31-24.06 11.94-34 3.74a24.44 24.44 0 0 1-3.57-34.89c10.79-13.38 21.82-26.57 32.7-39.87a13.06 13.06 0 0 0 1.38-2.89 14.41 14.41 0 0 0-3.39-1c-3.92-.19-7.85-.34-11.76-.21a23.77 23.77 0 0 1-24.57-23.95c-.15-13.79 10.32-24.36 24.49-24.64 11.51-.23 23-.05 34.54-.05 11.27-.01 22.53-.11 33.79.02Z",
    transform: "translate(0 -309)",
    style: {
      fill: "url(#zendrop-logo_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.71 442.46a17.78 17.78 0 0 1 3.78-10.13c6.67-8.29 10.81-13.46 17.82-21.15 2.58-2.84 4.63-1.47 5.53.74 4.1 10 6.35 16 9.95 26.29 4.1 11.69-5 24.36-17.39 24.64-1.18 0-2.37-.05-3.56-.07a19.06 19.06 0 0 1-16.13-20.32Z",
    transform: "translate(0 -309)",
    style: {
      fill: "#8472ed",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h800v182H0z"
  }));
};
export default SvgZendropLogo;